var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [
          _c(
            "div",
            { staticClass: "md-layout md-gutter md-alignment-top-center" },
            [
              _c("md-progress-spinner", {
                attrs: {
                  "md-diameter": 50,
                  "md-stroke": 5,
                  "md-mode": "indeterminate"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "md-layout md-gutter md-alignment-top-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-20 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
              },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-fab",
                    on: {
                      click: function($event) {
                        return _vm.goBack()
                      }
                    }
                  },
                  [_c("md-icon", [_vm._v("arrow_back")])],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-60 md-medium-size-70 md-small-size-100 md-xsmall-size-100"
              },
              [
                _c(
                  "md-card",
                  [
                    _c("md-card-header", [
                      _c("div", { staticClass: "md-title" }, [
                        _vm._v("Potenzielle Projektpartner")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("md-card-content", [
                      _c("p", [
                        _vm._v(
                          "Hier finden Sie eine Liste mit potenziellen Projektpartnern."
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.trainer
                        ? _c("div", [
                            _c("div", [
                              _vm._v(
                                "\n              Sie können auch passende Partner zu Ihrem Unternehmensprofil\n              angezeigt bekommen.\n              "
                              ),
                              _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  _c(
                                    "md-field",
                                    { staticClass: "horizontal-grow" },
                                    [
                                      _c("label", [
                                        _vm._v("Suchen Sie nach Unternehmen")
                                      ]),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        model: {
                                          value: _vm.searchterm,
                                          callback: function($$v) {
                                            _vm.searchterm = $$v
                                          },
                                          expression: "searchterm"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "no-link mt-3",
                                      attrs: {
                                        text: "",
                                        color: "primary",
                                        to: { name: "MyPartners" }
                                      }
                                    },
                                    [_vm._v("Ausgewählte Partner")]
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.searchresults, function(item) {
                      return _c(
                        "div",
                        { key: item.name, staticClass: "ma-3" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "no-link",
                              attrs: {
                                to: {
                                  name: "CompanyDetail",
                                  params: { hash: item.hash }
                                }
                              }
                            },
                            [
                              _c(
                                "md-card",
                                {
                                  staticClass:
                                    "margin-twenty md-alignment-top-center md-elevation-1",
                                  attrs: { "md-with-hover": "" }
                                },
                                [
                                  _c(
                                    "md-card-header",
                                    { staticClass: "md-title" },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                  _vm._v(" "),
                                  _c("md-card-content", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.shorten(item.description)
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "md-layout-item md-size-20 md-medium-size-15 md-small-size-10 md-xsmall-size-0"
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-196a5752", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-196a5752","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/profile/partners/Partners.vue
// module id = null
// module chunks = 